/** @jsxImportSource @emotion/react */
import colors from '@sportninja/common/constants/appColors'

interface QuestionTypeIconProps {
  size?: number
  color?: string
  className?: string
}

/**
 * BirthDateIcon component - Icon for birth date question type
 * @param size - Icon size in pixels (default: 24)
 * @param color - Icon color (default: colors.NEUTRAL_50)
 * @param className - Additional CSS class name
 */
const BirthDateIcon = ({
  size = 24,
  color = colors.NEUTRAL_50,
  className,
}: QuestionTypeIconProps) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 24 25'
      fill='none'
      className={className}
    >
      <path
        d='M12 7.5C13.11 7.5 14 6.6 14 5.5C14 5.12 13.9 4.77 13.71 4.47L12 1.5L10.29 4.47C10.1 4.77 10 5.12 10 5.5C10 6.6 10.9 7.5 12 7.5ZM18 10.5H13V8.5H11V10.5H6C4.34 10.5 3 11.84 3 13.5V22.5C3 23.05 3.45 23.5 4 23.5H20C20.55 23.5 21 23.05 21 22.5V13.5C21 11.84 19.66 10.5 18 10.5ZM19 21.5H5V18.5C5.9 18.49 6.76 18.13 7.4 17.49L8.49 16.42L9.56 17.49C10.87 18.8 13.15 18.79 14.45 17.49L15.53 16.42L16.6 17.49C17.24 18.13 18.1 18.49 19 18.5V21.5ZM19 17C18.49 16.99 18.01 16.8 17.65 16.43L15.52 14.3L13.38 16.43C12.64 17.17 11.35 17.17 10.61 16.43L8.48 14.3L6.34 16.43C5.99 16.79 5.51 16.99 5 17V13.5C5 12.95 5.45 12.5 6 12.5H18C18.55 12.5 19 12.95 19 13.5V17Z'
        fill={color}
      />
    </svg>
  )
}

export default BirthDateIcon
